import { PRICE_LEVELS } from '../../constants/priceLevels.js';

export const PAY_CODE_DEFAULT_COLS = ['pay_code_name', 'pay_category_name'];
export const HOL_DEFAULT_COLS = [
  'site_code', 'location_name', 'labor_metric_code', 'pay_category_name',
];

// Editable frozen-right columns shown on the Pay Code Rules table.
// fullLabel = picker text, abbr = column header.
export const EDITABLE_COLS = [
  { key: 'ignore_for_billing',   fullLabel: 'Exclude for Billing',                          abbr: 'Exclude',     group: 'Rule #1',          type: 'bool',     width: '4%' },
  { key: 'count_towards_ot',     fullLabel: 'Should Count Towards OT Recalc?',              abbr: 'OT Recalc?',  group: 'TAB07',            type: 'tri',      options: ['Yes', 'No', 'Yes (Worked Only)'], width: '4%' },
  { key: 'nb_hours_ot_eligible', fullLabel: 'NB Hours - Conversion Eligible for OT Recalc', abbr: 'NB OT?',      group: 'TAB07',            type: 'tri',      options: ['Yes', 'No', 'Yes (Worked Only)'], width: '4%' },
  { key: 'special_hol_mapping',  fullLabel: 'Apply Special HOL Price Level Mapping',        abbr: 'HOL Map',     group: 'TAB10',            type: 'bool',     width: '4%' },
  { key: 'default_price_level',  fullLabel: 'Default Price Level',                          abbr: 'Price Lvl',   group: 'Rule #5',          type: 'dropdown', options: PRICE_LEVELS, billableOnly: true, width: '6%' },
  { key: 'apply_billing_rules',  fullLabel: 'Apply Billing Rule Logic',                     abbr: 'Apply Rules', group: 'TAB01,02,03,05',   type: 'bool',     width: '5%' },
];

export const PAY_CODE_ABBR_MAP = {
  'Pay Code ID':            'Code ID',
  'Pay Category ID':        'Cat ID',
  'Default Multiplier':     'Multiplier',
  'Pay Category Conversion': 'Conversion',
  'Billing Type':           'Bill Type',
  'Converted Price Levels': 'Conv Levels',
};

export const PAY_CODE_COL_WIDTHS = {
  pay_code_id:        '3%',
  pay_code_name:      '10%',
  pay_category_id:    '3%',
  pay_category_name:  '7%',
};
